export default __webpack_public_path__ + "static/image4-3d71e6e9aadaf3e597e62baaa43b23b8.gif";